import { Spin, Button, Card, Col } from 'antd';
import Axios from 'axios';
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import BtnLike from '../../utils/BtnLike';
import ProductCard, { UserProfile } from '../../utils/ProductCard';
import { getThumbURLfromProduct } from '../../utils/YoutubeEmbed';
import { DivHorizental, DivVertical } from '../LandingPage/LandingPage';

const BtnMarginedVertical = styled(Button)`
    & + & {
        margin-top: 8px;
    }
`;

const SectionHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    margin-top: 10px;
`;

const DivUserInfo = styled.div`
    background: #fff;
    width: 100%;
    border-radius: 3px;
    padding: 10px;
`;

const MarginedCol = styled(Col)`
  & + & {
    margin-left: 0.5rem;
  }
`;

function ProfilePage(props) {

    const [Products, setProducts] = useState([]);
    const [Skip, setSkip] = useState(0);
    const [Limit, setLimit] = useState(10);
    const [PostSize, setPostSize] = useState();
    const [TargetUser, setTargetUser] = useState();
    const [Replies, setReplies] = useState([]);
    const [BlankMessage, setBlankMessage] = useState();

    useEffect(() => {
        const userObj = props.location?.state?.targetUser || props.user?.userData;
        getUserInfo(userObj?._id);
        getMyProducts({ targetUserId: userObj?._id });
    }, [props]);

    const getUserInfo = (userID) => {
        if (!userID) return console.log('can not find userID:', userID);
        Axios.get('/api/user/' + userID).then(res => {
            if (res.data.success) {
                setTargetUser(res.data.user);
                setReplies(res.data.user?.reply || []);
            }
        }).catch(err => console.log(err));
    }

    const getMyProducts = (variables) => {
        Axios.post('/api/product/getOurProducts', variables)
            .then(response => {
                if (response.data.success) {
                    let totalProducts;
                    if (variables?.loadMore || variables?.skip > Skip) {
                        totalProducts = [...Products, ...response.data.products];
                    } else {
                        totalProducts = response.data.products;
                    }
                    setProducts(totalProducts);
                    setPostSize(response.data.postSize);

                    if (!totalProducts?.length) setBlankMessage('참여 중인 프로젝트가 없습니다.');
                } else {
                    console.log('Failed to fectch product datas')
                }
            })
            .catch(err => console.log(err));
    };

    const renderProductCards = (products) => products?.map(product => {

        let imgURL = getThumbURLfromProduct(product);

        return <MarginedCol key={product._id} lg={15} md={15} xs={15}>
            <Link to={`/product/${product._id}`} >
                <Card cover={
                    imgURL && <img alt="productImg" src={imgURL} style={{ height: '20vh' }} />
                }>
                    <ProductCard product={product} user={product.writer} ellepsis />
                </Card>
            </Link>
        </MarginedCol>
    });

    const renderReply = (replies) => replies?.map(reply => {
        return <DivUserInfo key={reply._id}><DivHorizental>
            <UserProfile user={reply.writer} />
            <DivVertical style={{ width: '100%', overflow: 'hidden' }}>
                <DivHorizental margin='5px' style={{ marginLeft: 'auto' }}>
                    <BtnLike />
                    {(props?.user?.userData?._id == reply?.writer?._id) && <Button size='small' danger onClick={evt => {
                        if (window.confirm('댓글을 삭제하시겠습니까?')) {
                            Axios.delete('/api/user/reply/' + reply._id).then(response => {
                                if (response.data.success) {
                                    const arrReplies = replies.filter(re => re._id != reply._id);
                                    setReplies(arrReplies);
                                }
                                else {
                                    alert(response.data.reason);
                                    console.log('response.data.reason:', response.data.reason);
                                }
                            }).catch(err => {
                                console.log('err:', err);
                                alert(err.response.data.reason);
                                console.log('err.response.data.reason:', err.response.data.reason);
                            });
                        }
                    }}>삭제</Button>}
                </DivHorizental>

                <label style={{ height: '100%' }}>
                    {reply.message}
                </label>
            </DivVertical>
        </DivHorizental></DivUserInfo>
    });

    return <div className='page'>
        <DivUserInfo><DivHorizental>
            <DivVertical>
                <img src={TargetUser?.image} className='rounded-circle' style={{
                    width: '30vw',
                    maxWidth: '150px',
                    aspectRatio: '1',
                }} />
                <label style={{ wordBreak: 'keep-all', textAlign: 'center' }}>
                    {TargetUser?.name}
                </label>
            </DivVertical>
            <DivVertical style={{ width: '100%', overflow: 'hidden' }}>
                <DivHorizental margin='5px' style={{ marginLeft: 'auto' }}>
                    <BtnLike />
                    {(props?.user?.userData?._id == TargetUser?._id) && <Button size='small' onClick={(evt) => {
                        console.log('onClick ' + evt.target.innerHTML);
                        props.history.push({
                            pathname: "/register",
                            state: { ...props.user.userData, isModify: true }
                        });
                    }}>수정</Button>}
                </DivHorizental>

                <label style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {TargetUser?.email}
                </label>

                <label style={{ flex: 1 }}>
                    {TargetUser?.description}
                </label>

                <BtnMarginedVertical type='primary' onClick={(evt) => {
                    console.log('onClick ' + evt.target.innerHTML);
                    // props.history.push(`/chat_detail?name=${props?.user?.userData?.name}&room=${TargetUser?.name + ',' + props?.user?.userData?.name}`);
                    props.history.push({
                        pathname: "/chat_detail",
                        state: { secondMember: TargetUser }
                    });
                }}>메세지 보내기</BtnMarginedVertical>

                {(TargetUser?._id != props?.user?.userData?._id) && <BtnMarginedVertical onClick={(evt) => {
                    let message = prompt("추천사 쓰기");
                    if (message) {
                        Axios.post('/api/user/reply', { to: TargetUser._id, message })
                            .then(response => {
                                if (response.data.success) {
                                    console.log('추천사를 작성했습니다');
                                    setReplies([...Replies, { writer: props.user.userData, message }]);
                                } else {
                                    alert(response.data.reason);
                                }
                            })
                            .catch(err => console.log(err));
                    }
                }}>추천사 쓰기</BtnMarginedVertical>}
            </DivVertical>
        </DivHorizental></DivUserInfo>

        <SectionHeader>포트폴리오</SectionHeader>
        <DivHorizental style={{ width: '100%', overflow: 'auto' }}>
            {Products?.length ?
                renderProductCards(Products)
                :
                <h3>{BlankMessage || <Spin />}</h3>
            }
        </DivHorizental>

        {Replies?.length > 0 && <>
            <SectionHeader>추천사</SectionHeader>
            <DivVertical>
                {renderReply(Replies)}
            </DivVertical>
        </>}

    </div>;
}

export default ProfilePage;